import { Card, Typography, Chip, Stack, LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../../../assets/styles/tokens";
import { styled } from "@mui/material/styles";
import { linearProgressClasses } from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: spacing.Spacing.md.$value,
  borderRadius: spacing.Radius.xxs.$value,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: colors.Brand[500].$value,
    ...theme.applyStyles("dark", {
      backgroundColor: colors.Brand[500].$value,
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: spacing.Radius.xxs.$value,
    backgroundColor: colors.Brand[800].$value,
    ...theme.applyStyles("dark", {
      backgroundColor: colors.Brand[800].$value,
    }),
  },
}));

type StatusColor = "success" | "error";

interface AccountSummeryIncomeCardProps {
  date: string;
  totalIncome: string;
  cpa: string;
  cpaPercentage: string;
  cpaColor: StatusColor;
  rs: string;
  rsPercentage: string;
  rsColor: StatusColor;
  profit: string;
}

export function AccountSummeryIncomeCard({
  date,
  totalIncome,
  cpa,
  cpaPercentage,
  cpaColor,
  rs,
  rsPercentage,
  rsColor,
  profit,
}: AccountSummeryIncomeCardProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              m: 0,
            }}
          >
            {date}
          </Typography>
        </Stack>

        <Stack sx={{ mb: spacing.Spacing.xs.$value }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {totalIncome}
            </Box>
            Total Income of which
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: spacing.Spacing.xxs.$value }}
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.md.$value,
              }}
            >
              CPA
            </Typography>
            <Chip
              label={cpaPercentage}
              size="small"
              sx={{
                bgcolor:
                  cpaColor === "success"
                    ? colors.Brand[800].$value
                    : cpaColor === "error"
                      ? colors.Brand[500].$value
                      : "",

                color:
                  cpaColor === "success"
                    ? colors.Base.White.$value
                    : cpaColor === "error"
                      ? colors.Base.White.$value
                      : "",

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
          <Box
            display={"flex"}
            alignItems="center"
            sx={{ width: spacing.Spacing["8xl"].$value }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: 1,
              }}
            >
              RS
            </Typography>
            <Chip
              label={rsPercentage}
              size="small"
              sx={{
                bgcolor:
                  rsColor === "success"
                    ? colors.Brand[800].$value
                    : rsColor === "error"
                      ? colors.Brand[500].$value
                      : "",

                color:
                  rsColor === "success"
                    ? colors.Base.White.$value
                    : rsColor === "error"
                      ? colors.Base.White.$value
                      : "",

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
              }}
            >
              {cpa}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            alignItems="center"
            sx={{ width: spacing.Spacing["8xl"].$value }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            >
              {rs}
            </Typography>
          </Box>
        </Stack>

        {/* Progress Bar */}

        <BorderLinearProgress
          variant="determinate"
          value={parseInt(cpaPercentage)}
          sx={{ my: 0.5 }}
        />

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              Profit
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
              }}
            >
              {profit}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </>
  );
}

export default AccountSummeryIncomeCard;
